import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5c43b75e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c43b75e')) {
      api.createRecord('5c43b75e', component.options)
    } else {
      api.reload('5c43b75e', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=5c43b75e", function () {
      api.rerender('5c43b75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/footer.vue"
export default component.exports